import { notification } from 'antd'
import { publicAPI } from '../../Config/Constant'
import store from '../store'



//add

export const addCampagin = async(payload,navigate) => {
 
     try {
       const res = await publicAPI.post('/campaign/create', payload)
       if (res) {
       
         if (res) {
           notification.success({
             description: res.data.data.message,
             duration: 2,
           })

            return res
           // }
         } 
         

       }
     } catch (err) {
       console.error('Error during login:', err); 
       notification.error({
         message: err?.response?.data?.message || 'Server Error',
         duration: 3,
       })
     }
   
 }

 export const getCampaign = async(payload) => {
      try {
       const res = await publicAPI.get(`/campaign/get/${payload.organizationid}`,)
         if (res) {
          
            store.dispatch({
                type: 'SET_ALL_CAMPAIGN',
                payload: res.data.data,
              })
   
            return res       

       }
     } catch (err) {

       notification.error({
         message: err?.response?.data?.message || 'Server Error',
         duration: 3,
       })
     }
   
 }


 export const detailCampaign = async(payload) => {
   try {
     const res = await publicAPI.get(`/campaign/get-detail/${payload.campaignid}`,)
       if (res) {
        
          store.dispatch({
              type: 'SET_ALL_CAMPAIGN',
              payload: res.data.data,
            })
 
          return res       

     }
   } catch (err) {

     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}


 export const deleteCampaign = async(payload) => {
    try {
     const res = await publicAPI.post('/campaign/delete', payload)
     if (res) {
          return res
     }
   } catch (err) {

     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}

// edit
 
export const EditCampagin = async(payload) => {
    try {
     const res = await publicAPI.post('/campaign/edit', payload)
     if (res) {
     
       if (res) {
         notification.success({
           description: res.data.data.message,
           duration: 2,
         })

          return res
         // }
       } 
       

     }
   } catch (err) {
     console.error('Error during login:', err); 
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}
